import React from "react";
import { SimpleGrid, Paper, Text, Group } from "@mantine/core";

const QuizStatCards = ({ stats }) => {
  const cards = [
    { label: "Active Quizzes", value: stats?.activeQuizzes ?? 0 },
    { label: "Total Participants", value: stats?.totalParticipants ?? 0 },
    { label: "Passed", value: stats?.totalPassed ?? 0 },
    { label: "Pending", value: stats?.totalPending ?? 0 },
  ];

  return (
    <SimpleGrid cols={4} mb="lg">
      {cards.map((card) => (
        <Paper key={card.label} p="md" withBorder radius="md">
          <Text size="xs" color="dimmed" transform="uppercase" weight={600}>
            {card.label}
          </Text>
          <Group position="apart" mt="xs">
            <Text size="xl" weight={700}>
              {card.value}
            </Text>
          </Group>
        </Paper>
      ))}
    </SimpleGrid>
  );
};

export default QuizStatCards;
